import { StyleSheet, Text, View } from 'react-native'
import React, { useContext } from 'react'
import { DataContext } from '../components/DataContext'

export default function useData() {
    const context = useContext(DataContext)

    return context
}

const styles = StyleSheet.create({})